import { SurveyFilePreview as ReactSurveyFilePreview } from 'survey-react-ui';
import classNames from 'classnames';

import { SurveyFilePreviewPage } from './SurveyFilePreviewPage/SurveyFilePreviewPage';

import styles from './SurveyFilePreview.module.scss';

export class SurveyFilePreview extends ReactSurveyFilePreview {
  protected renderElement(): JSX.Element | null {
    const content = this.question.supportFileNavigator
      ? this.question.renderedPages.map((page: any) => {
          return (
            <SurveyFilePreviewPage
              page={page}
              question={this.question}
              key={page.id}
            ></SurveyFilePreviewPage>
          );
        })
      : this.question.previewValue.map((_item: any, _index: number) => {
          return 'SurveyFileItem';
          //   return (
          //     <SurveyFileItem
          //       item={item}
          //       question={this.question}
          //       key={index}
          //     ></SurveyFileItem>
          //   );
        });
    return (
      <div
        className={classNames(
          this.question.cssClasses.fileList,
          styles.root,
          styles.list
        )}
      >
        {content}
      </div>
    );
  }
}
